export default __webpack_public_path__ + "static/media/hosting1.097e6348.png";